import * as React from 'react';
import { SVGProps } from 'react';

export function SendIcon(props: SVGProps<SVGSVGElement>) {
  const { fill = 'none', color } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill={fill}>
      <path
        d="M23.3304 2.33228C23.6072 1.54146 22.847 0.781283 22.0562 1.05807L2.15932 8.02197C1.36755 8.29909 1.24831 9.36922 1.95967 9.81382L8.85308 14.1222L15.7179 7.25736C16.1083 6.86699 16.7412 6.86699 17.1316 7.25735C17.5219 7.64772 17.5219 8.28063 17.1316 8.67099L10.2666 15.5359L14.5746 22.4288C15.0192 23.1401 16.0894 23.0209 16.3665 22.2291L23.3304 2.33228Z"
        fill={color}
      />
    </svg>
  );
}
